import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PriApprovedWith from "./PriApprovedWith";
import PriRejectedWith from "./PriRejectedWith";
import PriPendingWith from "./PriPendingWith";
import "bootstrap/dist/css/bootstrap.min.css";
import "./With.css";
import PriHoldWith from "./PriHoldWith";
import PriApprovedHoldWith from "./PriApprovedHoldWith";

const PriWithdrawControls = () => {
  const bonuses = [
    { title: "Pending Withdraw", value: "principal_pending_withdrawal" },
    { title: "Approved Withdraw", value: "principal_approved_withdrawal" },
    // { title: "Rejected Withdraw", value: "principal_rejected_withdrawal" },
    { title: "Hold Withdraw", value: "principal_hold_withdrawal" },
    { title: "Approved Hold Withdraw", value: "principal_approved_hold_withdrawal" },
  ];
  const [activeTab, setActiveTab] = useState(bonuses[0]);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    const activeTab =
      bonuses.find((bonus) => bonus.value === tab) || bonuses[0];
    setActiveTab(activeTab);
    // console.log("activeTab", activeTab)
  }, [location.search]);

  function handleTabClick(value) {
    setActiveTab(value);
    navigate(`?tab=${value.value}`);
  }
  return (
    <div className="container mt-4">
      <div className="tab-container">
        {bonuses.map((x, i) => (
          <div
            key={i}
            className={`tab ${x.value === activeTab.value ? "active" : ""}`}
            onClick={() => handleTabClick(x)}
          >
            {x.title}
          </div>
        ))}
      </div>
      <div className="tab-content">
        {activeTab.value === "principal_pending_withdrawal" && (<PriPendingWith />)}
        {activeTab.value === "principal_approved_withdrawal" && ( <PriApprovedWith />)}
        {activeTab.value === "principal_rejected_withdrawal" && ( <PriRejectedWith /> )}
        {activeTab.value === "principal_hold_withdrawal" && ( <PriHoldWith />)}
        {activeTab.value === "principal_approved_hold_withdrawal" && ( <PriApprovedHoldWith />)}
        {/*
    bonuses.map((x,i)=>{
        return <div style={{background: x?.value === activeTab.value ? "green" :"red" }} onClick={()=>handleTabClick(x)}>
        {x.title}
        </div>
        })
    */}
      </div>
    </div>
  );
};

export default PriWithdrawControls;
